module.exports = function getResource(label, vars = []) {
    let resources = {
        payWithText: 'Pay With'
    };

    return resources[label];
};
